import {Image} from "@/entities/Image";

export default class Product {
  constructor(obj, imgBasePath) {
    this.id = obj.id;
    this.slug = obj.slug;
    this.name = obj.name;
    this.abstract = obj.abstract;
    this.description = obj.description;
    this.price = obj.price;
    this.specs = obj.specs;
    this.img = new Image(obj.img, imgBasePath);
    this.order = obj.Order;
    this.type = obj.Tipo;
  }
}